<template>
  <div class="form-switch field">
    <ValidationProvider
      ref="validationProvider"
      :rules="rules"
      v-slot="validationProps"
      :name="formattedLabel"
      :value="computedValue"
    >
      <SwitchView
        v-model="computedValue"
        :true-value="trueValue"
        :false-value="falseValue"
        :size="size"
        :disabled="readOnly"
        @input="onInput"
      >
        <slot>
          <span v-if="!showTooltip" class="label m-b-0" :style="{ opacity: opacityValue }">
            {{ formattedLabel }}
            <p v-if="subLabel" class="is-size-6 has-text-grey m-b-5">
              <span>{{ subLabel }}</span>
            </p>
          </span>
          <TooltipView
            v-else-if="showTooltip"
            type="is-dark"
            position="is-top"
            :label="tooltipLabel"
            :multilined="true"
            dashed
          >
            <span class="label" :style="{ opacity: opacityValue }">{{ formattedLabel }}</span>
          </TooltipView>
        </slot>
      </SwitchView>
      <slot name="error" v-bind="validationProps">
        <span class="has-text-danger is-size-7 m-t-3 is-absolute">
          {{ getErrorFormattedText(validationProps) }}
        </span>
      </slot>
    </ValidationProvider>
    <div class="addons" v-if="$slots.addons">
      <slot name="addons"></slot>
    </div>
  </div>
</template>

<script>
import ValidationProvider from '/@/modules/core/form/components/ValidationProvider.vue';
import { FormInputMixin } from '/@/modules/core/form/mixins/FormInputMixin';
import { FormValidationMixin } from '/@/modules/core/form/mixins/FormValidationMixin';
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';
import SwitchView from '@/modules/core/ui/components/wrappers/SwitchView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FormSwitch',
  emits: ['on-change'],
  slotsDefinition: {
    error: { validationProps: Object },
    addons: {}
  },
  mixins: [FormInputMixin, FormValidationMixin],
  components: { SwitchView, TooltipView, ValidationProvider },
  props: {
    trueValue: { type: Boolean, default: true },
    falseValue: { type: Boolean, default: false },
    subLabel: { type: String },
    fadeWhenFalse: { type: Boolean, default: false },
    readOnly: { type: Boolean, default: false },
    tooltipLabel: { type: String },
    size: {
      type: String,
      default: 'is-small',
      validator: (prop) => ['is-small', 'is-default', 'is-medium', 'is-large'].includes(prop)
    }
  },
  computed: {
    opacityValue() {
      if (!this.fadeWhenFalse) {
        return 1;
      }
      return this.fadeWhenFalse && this.trueValue === this.computedValue ? 1 : 0.6;
    }
  },
  methods: {
    onInput(value) {
      this.$emit('on-change', value);
    }
  }
};
</script>

<style scoped>
.addons {
  margin-top: var(--ce-4px);
}
</style>
